/** True for the standard undo chord (⌘Z / Ctrl+Z), either letter case. No redo (Shift handled by caller). */
export function isUndoChord(e: {
  metaKey: boolean
  ctrlKey: boolean
  key: string
}): boolean {
  return (e.metaKey || e.ctrlKey) && (e.key === "z" || e.key === "Z")
}
